// [COMPONENT_ROUTES_IMPORTS_START]
import BgtPage from "../pages/bgtPage/BgtPage"
import RealisticIsraelPage from "../pages/realisticIsrael/RealisticIsraelPage"
import GoogleMeetPage from "../pages/googleMeet/GoogleMeetPage"
import ManagerApp from "../../manager/app/App"
import PersonalAssistantBotPage from "../pages/personalAssistantBotPage/PersonalAssistantBotPage"
// [COMPONENT_ROUTES_IMPORTS_END]

// [COMPONENT_ROUTES_TYPE_START]
const ComponentsRoutesTypeTeacher = {
    bgt: BgtPage,
    realisticIsrael: RealisticIsraelPage,
    googleMeet: GoogleMeetPage,
    managerDashboard: ManagerApp,
    bots: PersonalAssistantBotPage
}
// [COMPONENT_ROUTES_TYPE_END]
export default ComponentsRoutesTypeTeacher